import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-mini-card',
  templateUrl: './mini-card.component.html',
  styleUrls: ['./mini-card.component.scss'],
})
export class MiniCardComponent {
  @Input() matIconName!: string;
  @Input() text!: string;
  @Input() textAndIconColor!: string;
  @Input() borderColor!: string;
  @Input() backgroundColor!: string;

  constructor() {}
}
